import clsx from "clsx";
import { ListChecks } from "lucide-react";
import { useProgramSetup } from "@/lib/programSetup";

function attentionLabel(openCount: number, requiredCount: number): string {
  if (requiredCount > 0 && requiredCount === openCount) {
    return openCount === 1
      ? "1 erforderlicher Einrichtungsschritt ist offen"
      : `${openCount} erforderliche Einrichtungsschritte sind offen`;
  }
  if (requiredCount > 0) {
    return `${openCount} Einrichtungsschritte offen, davon ${requiredCount} erforderlich`;
  }
  return openCount === 1
    ? "1 empfohlener Einrichtungsschritt ist offen"
    : `${openCount} empfohlene Einrichtungsschritte sind offen`;
}

export function ProgramSetupIndicator() {
  const { setup, panelOpen, openPanel } = useProgramSetup();
  const openCount = setup?.steps.length ?? 0;
  if (!setup || openCount === 0) return null;

  const requiredCount = setup.required_open_count;
  const urgent = requiredCount > 0;
  const label = attentionLabel(openCount, requiredCount);

  return (
    <button
      type="button"
      onClick={openPanel}
      aria-haspopup="dialog"
      aria-expanded={panelOpen}
      aria-label={label}
      title={label}
      className={clsx(
        "inline-flex h-9 shrink-0 items-center gap-1.5 rounded-full border px-2 text-sm font-medium transition sm:px-2.5",
        urgent
          ? "border-status-orange/40 bg-status-orange/10 text-status-orange hover:bg-status-orange/15"
          : "border-accent/35 bg-accent-soft text-accent hover:bg-accent-soft/80",
      )}
    >
      <ListChecks size={16} strokeWidth={2} aria-hidden />
      <span className="hidden md:inline">Einrichtung</span>
      <span
        className={clsx(
          "min-w-[1.25rem] rounded-full px-1.5 text-center text-xs font-bold tabular-nums",
          urgent ? "bg-status-orange/15" : "bg-card/80",
        )}
      >
        {openCount}
      </span>
    </button>
  );
}
